import { render } from "./MemoruTop.vue?vue&type=template&id=2dc45b4e&ts=true"
import script from "./MemoruTop.vue?vue&type=script&lang=ts"
export * from "./MemoruTop.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__